<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" size="small" plain @click.stop="downloadExcelAddMoney">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="url">
          <viewer :images="formmaterImage(scope.row.url)">
            <img v-for="src in formmaterImage(scope.row.url)" :src="src" :key="src" width="30" />
          </viewer>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { accountDetailsOption } from "@/const/salesCloud/accountDetailsOption";
import {
  findAccountDetails,
  findAccountDetailsDownloadExcel
} from "@/api/salesCloud/accountDetails";
import { excelaxios } from "@/util/excelaxios";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "accountDetails",
  components: {},
  data() {
    return {
      tableOption: accountDetailsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      this.downloadData = params;
      findAccountDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findAccountDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.createTimeStart = params.startDate_endDate[0];
        params.createTimeEnd = params.startDate_endDate[1];
      } else {
        delete params.createTimeStart;
        delete params.createTimeEnd;
      }
      this.downloadData = params;
      findAccountDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findAccountDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      this.$refs.crud.rowEdit(row, index);
    },
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;

      findAccountDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) { },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) { },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) { },
    downloadExcelAddMoney() {
      let params = this.downloadData;
      // let url = `/joins-wallet/v1/app_detail/excel?`;
      // excelaxios(url, params);
      findAccountDetailsDownloadExcel(params).then((res) => {
        window.open(res);
      });
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
